"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildSeatTypes = exports.ChildSeatType = void 0;
var ChildSeatType;
(function (ChildSeatType) {
    ChildSeatType[ChildSeatType["RearFacing"] = 0] = "RearFacing";
    ChildSeatType[ChildSeatType["ForwardFacing"] = 1] = "ForwardFacing";
    ChildSeatType[ChildSeatType["BoosterSeat"] = 2] = "BoosterSeat";
    ChildSeatType[ChildSeatType["Booster"] = 3] = "Booster";
})(ChildSeatType || (exports.ChildSeatType = ChildSeatType = {}));
exports.ChildSeatTypes = [
    {
        childSeatType: ChildSeatType.RearFacing,
        yearsDifference: 1,
        yearsFrom: 0,
    },
    {
        childSeatType: ChildSeatType.ForwardFacing,
        yearsDifference: 3,
        yearsFrom: 1,
    },
    {
        childSeatType: ChildSeatType.BoosterSeat,
        yearsDifference: 2,
        yearsFrom: 4,
    },
    {
        childSeatType: ChildSeatType.Booster,
        yearsDifference: 6,
        yearsFrom: 6,
    },
];
//# sourceMappingURL=ChildSeatType.js.map